export default {
  name: 'dropDown',
  icon: {
    tag: 'svg',
    attrs: { viewBox: '0 0 16 16', width: '16', height: '16', fill: 'none' },
    children: [
      {
        tag: 'path',
        attrs: {
          d: 'M4.60262 6.02388C4.32371 5.57757 4.64617 5 5.17425 5H10.8261C11.346 5 11.6694 5.5623 11.4068 6.00896C10.4089 7.70642 9.67075 8.96194 8.66766 10.6682C8.41176 11.1035 7.78244 11.1123 7.51481 10.684L4.60262 6.02388Z',
          fill: '#757575',
        },
      },
    ],
  },
}
